export default __webpack_public_path__ + "ab1c00c489792ffbdf72d87e50b00a65.jpg";